import { InfiosFormatDate } from '@infios/uikit/react';

interface FormattedDateTimeProps {
  iso: string | undefined;
}

/**
 * Renders an ISO timestamp as a locale-aware date + time, in the browser's
 * own timezone — `Date` parses the ISO string's UTC/offset info and
 * `InfiosFormatDate` (Intl.DateTimeFormat under the hood) renders it back out
 * using the user's locale, which defaults to their local timezone unless a
 * `timeZone` override is given (none is, here, intentionally).
 */
export function FormattedDateTime({ iso }: FormattedDateTimeProps) {
  if (!iso) return <>—</>;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return <>{iso}</>;

  return (
    <InfiosFormatDate
      date={date}
      year="numeric"
      month="short"
      day="numeric"
      hour="numeric"
      minute="numeric"
      hourFormat="auto"
    />
  );
}
